module.exports = __webpack_public_path__ + "resources/img/img_datahunt7.fe1a597980588317febbe007a705d4b3.png";